import FormControls from 'component/FormControls';
import Modal from 'component/Modal';
import Page from 'component/Page';
import Table from 'component/Table';
import { Button } from 'react-bootstrap';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { selectSearchRangeDate } from 'redux/app/app.selector';
import { selectCurrentUser } from 'redux/user/user.selector';
import { sendPost } from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import {
  adjustDate,
  formatDate,
  formatLocalDate,
  truncTime,
  setHours,
  emailValidate,
  nNU,
  formatSeconds,
  formatTime,
} from 'util/utils';
import { useMemo } from 'react';
import { validate } from 'uuid';

const ChannelLogs = () => {
  const currentUser = useSelector(selectCurrentUser);
  const [ page, setPage ] = useState(1);
  const [ total, setTotal ] = useState(0);
  const [ pageSize, setPageSize ] = useState(10);
  const searchRangeDate = useSelector(selectSearchRangeDate);
  const [ mailAlertData, setMailAlertData ] = useState(null);
  const [ addr, setAddr ] = useState(null);
  const history = useHistory();
  const infoAction = ({ raw }) => setMailAlertData(raw);
  const [ searchId, setSearchId ] = useState('');
  const [ data, setData ] = useState([]);
  const [ debouncedSearchId, setDebouncedSearchId ] = useState(searchId);
  const isMonitorOnly = useMemo(
    () => currentUser.isMonitorOnly === 1,
    [ currentUser.isMonitorOnly ]
  );

  const [ searchData, setSearchData ] = useState({
    fromDate: searchRangeDate?.[ 0 ] || truncTime(adjustDate(new Date(), -7)),
    toDate: searchRangeDate?.[ 1 ] || truncTime(),
  });
  const formControls = [
    {
      type: 'rangeDate',
      title: string.LOG_TIME,
      onChange: (e) =>
        setSearchData({
          ...searchData,
          fromDate: e[ 0 ],
          toDate: e[ 1 ],
        }),
      options: {
        defaultDate: [ searchData.fromDate, searchData.toDate ],
      },
    },
  ];
  const title = string.CHANNELLOG;
  const headers = [
    string.CALLLOG_CH,
    string.STARTED_TIME,
    string.CALLLOG_LENGTH,
    // string.PROCESSED_RESULT,
    // string.DEVICE_NAME,
    // string.DEVICE_ALERT_DETAIL,
    // string.DEVICE_ALERT_DETECTION_TIME,
    // string.DEVICE_ALERT_RESOLUTION_TIME,
    // string.DEVICE_ALERT_DETECTION_PERIOD,
  ];
  const csvHeaders = [
    string.DEVICE_SIGFOX_ID,
    string.DEVICE_NAME,
    string.DEVICE_ALERT_DETAIL,
    string.DEVICE_ALERT_DETECTION_TIME,
    string.DEVICE_ALERT_DETECTION_LAT,
    string.DEVICE_ALERT_DETECTION_LONG,
    string.DEVICE_ALERT_DETECTION_DEVICE_URL,
    string.DEVICE_ALERT_DETECTION_MAP_URL,
    // string.DEVICE_ALERT_RESOLUTION_TIME,
    // string.DEVICE_ALERT_DETECTION_PERIOD,
  ];

  // eslint-disable-next-line no-unused-vars
  const dataTable = useCallback(
    (data) =>
      data.map((raw, key) => ({
        key,
        data: [
          !nNU(raw?.groupName) ? "" :
            (raw?.groupName === 'CH.9999') ? "コール" : raw?.groupName,
          formatLocalDate(raw?.startedAt, 'YYYY-MM-DD HH:mm:ss'),
          formatSeconds(raw.length),
        ],
        raw,
      })),
    []
  );
  const doSearch = useCallback(
    async (page, pageSize, searchId, getAll = false) => {
      const fromDate = setHours(searchData.fromDate, 0, 0, 0, 0);
      const toDate = setHours(truncTime(searchData.toDate), 23, 59, 59, 999);
      // fromDate.setHours(fromDate.getHours() + 7);
      // toDate.setHours(toDate.getHours() + 7);
      let body = {
        ...(!searchData?.fromDate
          ? null
          : {
            startProcessedDate: searchData.fromDate.toISOString(),
          }),
        ...(!searchData?.toDate
          ? null
          : {
            endProcessedDate: searchData.toDate.toISOString(),
          }),
        ...(!nNU(searchId) || searchId.length === 0
          ? null
          : {
            email: searchId,
          }),
        // email: currentUser.email,
        // detectionTime: new Date(),
        offset: (page - 1) * pageSize,
        size: pageSize,
        keyword: searchId,
      };
      console.log(body?.email);
      if (!body?.startProcessedDate || !body?.endProcessedDate) {
        return;
      }
      let data = await sendPost({
        url: Urls.account.channellog,
        body,
      });
      const { total, result } = data;
      if (!getAll) {
        setData(result);
        setTotal(total);
      }
      return result;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ searchData ]
  );

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchId(searchId);
    }, 500);

    return () => {
      clearTimeout(timerId);
    };
  }, [ searchId ]);

  useEffect(() => {
    doSearch(page, pageSize, debouncedSearchId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ page, pageSize, debouncedSearchId, doSearch ]);

  return (
    <>
      <Page
        title={<>{title}</>}
        body={
          <>
            <FormControls controls={formControls} />
            <Table
              className="nowrap"
              page={page}
              //actions={actions}
              pageSize={pageSize}
              total={total}
              onPageChanged={setPage}
              onPageSizeChanged={setPageSize}
              headers={headers}
              // csvHeaders={csvHeaders}
              data={dataTable(data)}
              getCSVData={!isMonitorOnly && (async () => {
                return dataTable(await doSearch(1, total, '', true));
              })}
              csvFileName="Channel_Log"
              search={true}
              onSearch={(value) => setSearchId(value)}
              placeHolder={`${string.CALLLOG_CH}`}
            />
          </>
        }
      />
    </>
  );
};

export default ChannelLogs;
